import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PedalBikeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"pedal_bike"}/>
}
